import APIServer from './APIServer'

export default class MonetizationAPI extends APIServer { 

	setAuth(auth) { 
		super.setAuth(auth)
	}

	async sendMonetizationCompletion(data) { 
 		return await super.post('/monetization/completion', data)
 	}

 	async getCompletions(eventId) { 
 		return await super.get('/monetization/completions/' + eventId.toString())
 	}

}